import { render, staticRenderFns } from "./CohortSearchDropdown.vue?vue&type=template&id=3e8bfe56&scoped=true"
import script from "./CohortSearchDropdown.vue?vue&type=script&lang=js"
export * from "./CohortSearchDropdown.vue?vue&type=script&lang=js"
import style0 from "./CohortSearchDropdown.vue?vue&type=style&index=0&id=3e8bfe56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8bfe56",
  null
  
)

export default component.exports